const ArrowRightIcon = ({ishome, width = 20, height = 20}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 22 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.2275 5.43579L18.7917 11L13.2275 16.5641"
			stroke={ishome ? 'white' : 'currentColor'}
			stroke-width="1.375"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M3.20801 11H18.6355"
			stroke={ishome ? 'white' : 'currentColor'}
			stroke-width="1.375"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
export default ArrowRightIcon;
